import { render, staticRenderFns } from "./ConversationInitialize.vue?vue&type=template&id=624477f1&"
import script from "./ConversationInitialize.vue?vue&type=script&lang=js&"
export * from "./ConversationInitialize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports